export default __webpack_public_path__ + "static/media/Mantenimiento_.edbb0ca8.png";